import { render, staticRenderFns } from "./authName.vue?vue&type=template&id=4ace16e8&scoped=true"
import script from "./authName.vue?vue&type=script&lang=js"
export * from "./authName.vue?vue&type=script&lang=js"
import style0 from "./authName.vue?vue&type=style&index=0&id=4ace16e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ace16e8",
  null
  
)

export default component.exports